{
  "version": 1,
  "asset_id": "7f8b5c01-1767-4380-9684-10cd9f1a91c2",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/7f8b5c01-1767-4380-9684-10cd9f1a91c2/form-12153.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/7f8b5c01-1767-4380-9684-10cd9f1a91c2/form-12153.jpg",
  "original_filename": "form-12153.jpg",
  "size": 157634,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:39:13Z"
}
